import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Card } from "primereact/card";
import { Button } from "primereact/button";

import { Answer, Feedback } from "./Feedback";
import { fetchFeedbackById, submitFeedback } from "./feedbackApi";
import { routes } from "../../common/routing/routes";
import FeedbackForm from "./FeedbackForm";
import LoadingSpinner from "../../common/components/loadingSpinner/LoadingSpinner";

const FEEDBACK_QUESTION = "Te rugam sa ne spui cum ai evalua experienta ta recenta";

export default function TicketFeedbackPage() {
  const navigate = useNavigate();
  const { feedbackId } = useParams<{ feedbackId: string }>();
  const [feedback, setFeedback] = useState<Feedback>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!feedbackId) {
      navigate(routes.notFound.path);
      return;
    }
    const doFetchFeedback = async () => {
      const fetchedFeedback = await fetchFeedbackById(feedbackId);
      if (!fetchedFeedback) {
        navigate(routes.notFound.path);
        return;
      }
      setFeedback(fetchedFeedback);
      setIsLoading(false);
    };

    doFetchFeedback();
  }, []);

  const onSubmit = async (answer: Answer) => {
    setIsLoading(true);
    const newFeedback: Feedback = {
      ...feedback!,
      question: FEEDBACK_QUESTION,
      answer,
    };
    await submitFeedback(newFeedback);
    setFeedback(newFeedback);
    setIsLoading(false);
  };

  return (
    <Card title="Părerea ta contează pentru noi" className="mt-8">
      {isLoading ? (
        <LoadingSpinner />
      ) : feedback?.answer ? (
        <div className="text-center">
          <h3>Mulțumim pentru timpul tău și pentru feedback-ul oferit!</h3>
          <Button
            type="button"
            className="mx-auto"
            outlined
            label="Pagina principală"
            icon="pi pi-home"
            onClick={() => navigate(routes.dashboard.path)}
          />
        </div>
      ) : (
        <FeedbackForm question={FEEDBACK_QUESTION} onSubmit={onSubmit} />
      )}
    </Card>
  );
}
